import type { IamData } from 'features/iam/services/user-service';

const isEmailLike = (value: string): boolean => value.includes('@');

export function getUserDisplayName(
  user: Partial<IamData> | null | undefined,
  fallback = ''
): string {
  if (!user) return fallback;

  let firstName = typeof user.firstName === 'string' ? user.firstName.trim() : '';
  let lastName = typeof user.lastName === 'string' ? user.lastName.trim() : '';

  if (isEmailLike(firstName)) firstName = '';
  if (isEmailLike(lastName)) lastName = '';

  if (firstName || lastName) {
    return [firstName, lastName].filter(Boolean).join(' ').trim();
  }

  const emailPrefix =
    typeof user.email === 'string' && user.email.includes('@') ? user.email.split('@')[0] : '';
  if (emailPrefix) return emailPrefix;

  const userName = typeof user.userName === 'string' ? user.userName.trim() : '';
  if (userName) {
    return isEmailLike(userName) ? userName.split('@')[0] : userName;
  }

  return fallback;
}

